import { createFormatForDescription as cffd } from '../createFormatForDescription'
import { Explanation, explain } from '../explain/Explanation'
import SetRegularKeyInstructions from '../types/instructions/SetRegularKeyInstructions'
import TransactionType from '../types/TransactionType'

/**
 * Annotate SetRegularKey transaction.
 *
 * @property type - The transaction type.
 * @property regularKey - An explanation of the regularKey.
 */
export interface SetRegularKeyAnnotation {
  readonly type: TransactionType.SetRegularKey
  readonly regularKey: Explanation<string>
}

/**
 * Takes a transaction object and returns an annotated transaction object.
 * The returned object contains explanations about the various transaction features.
 *
 * @param transactionInstructions - The input transaction.
 * @returns An annotated transaction object detailing the various transaction features.
 */
export function annotate(
  transactionInstructions: SetRegularKeyInstructions,
): SetRegularKeyAnnotation {
  const regularKey = transactionInstructions.RegularKey
    ? explain(
        transactionInstructions.RegularKey,
        `The new regular key pair for this account is ${cffd(
          transactionInstructions.RegularKey,
          'regularKey',
        )}`,
      )
    : explain('', 'This transaction removes the existing regular key pair.')

  return {
    type: TransactionType.SetRegularKey,
    regularKey,
  }
}
